import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from './ResponseError.module.css'

interface Props {
    error: number | null
}

let ResponseError = ({error}: Props) => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <div
            className={style.container}
            style={{
                border: `1px solid ${Colors[theme ?? 'light'].borderLight}`,
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].secondBackground,
                //boxShadow: `0px 0px 5px ${Colors[theme ?? 'light'].shadow}`
            }}
        >
            {error
                ? <>
                    <div className={style.icon}>
                        <i className="fa-solid fa-circle-xmark"></i>
                    </div>
                    <div className={style.text}>
                        {Strings[language ?? 'tm']['error' + error]}!
                    </div>
                </>
                : null
            }
        </div>
    )
}

export default ResponseError